import pix from "@/modules/Pix/pages/Index.vue";

export default [
  {
    path: "/pix/:id_transaction_digital",
    component: pix,
    meta: { title: "Pix - Nuts" },
  },
];
